import React from "react";
import { SOCIAL_LINKS } from "@/components/site/socials";

const socials = SOCIAL_LINKS;

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-vintage-bg text-vintage-cream/70 pt-20 pb-10 px-6 md:px-12 border-t border-vintage-cream/10"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <span className="text-vintage-gold font-subheading italic text-3xl leading-none">
              Otto Junior
            </span>
          </div>
          <p className="font-subheading italic text-vintage-cream/60 mt-5 max-w-md">
            Blues artist from Norway, sponsored by Gibson guitars — playing
            shows around the world with his unique band.
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="font-mono text-[10px] tracking-[0.35em] uppercase text-vintage-rust mb-4">
            Visit
          </p>
          <ul className="space-y-2 font-body">
            <li><a href="#tour" data-testid="footer-link-tour" className="hover:text-vintage-rust">Tour Dates</a></li>
            <li><a href="#about" data-testid="footer-link-about" className="hover:text-vintage-rust">About</a></li>
            <li><a href="#videos" data-testid="footer-link-videos" className="hover:text-vintage-rust">Live Videos</a></li>
            <li><a href="#pictures" data-testid="footer-link-pictures" className="hover:text-vintage-rust">Pictures</a></li>
            <li><a href="#contact" data-testid="footer-link-contact" className="hover:text-vintage-rust">Contact</a></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="font-mono text-[10px] tracking-[0.35em] uppercase text-vintage-rust mb-4">
            Bookings &amp; Press
          </p>
          <p className="font-body text-vintage-cream/75">
            <a href="mailto:ojr.lagarhus@gmail.com" className="hover:text-vintage-rust" data-testid="footer-mail-mgmt">
              ojr.lagarhus@gmail.com
            </a>
          </p>
          <p className="font-body text-vintage-cream/75 mt-2">
            <a href="tel:+4794173045" className="hover:text-vintage-rust" data-testid="footer-phone">
              +47 941 73 045
            </a>
          </p>

          <div className="flex items-center gap-4 mt-6 flex-wrap">
            {socials.map((s) => {
              const Icon = s.icon;
              const isPatreon = s.label === "Patreon";
              return (
                <a
                  key={s.label}
                  href={s.href}
                  aria-label={s.label}
                  data-testid={`footer-social-${s.label.toLowerCase()}`}
                  className={`inline-flex items-center justify-center border border-vintage-cream/20 hover:border-vintage-rust hover:text-vintage-rust transition-colors ${
                    isPatreon
                      ? "px-3 h-10 font-mono text-[10px] tracking-[0.25em] uppercase"
                      : "w-10 h-10"
                  }`}
                >
                  {isPatreon ? "Patreon" : <Icon size={18} />}
                </a>
              );
            })}
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-16 pt-6 border-t border-vintage-cream/10 flex flex-col md:flex-row items-center justify-between gap-3">
        <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-vintage-cream/40">
          © {new Date().getFullYear()} Otto Junior · All Rights Reserved
        </p>
        <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-vintage-cream/40">
          Cut to tape · Mixed by lamplight
        </p>
      </div>
    </footer>
  );
}
